/**
 * NAD Handpicked Reviews
 * Turns the handpicked reviews block into a Swiper slider so it is
 * draggable on desktop (mouse) and swipeable on touch devices.
 */
import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

Swiper.use([Pagination, Autoplay]);

export class NADHandpickedReviews {
  private element: HTMLElement;
  private container: HTMLElement | null;
  private swiper: Swiper | null = null;

  constructor(element: HTMLElement) {
    this.element = element;
    this.container = element.querySelector('[data-handpicked-reviews]');
    this.init();
  }

  private init(): void {
    if (!this.container) return;

    this.swiper = new Swiper(this.container, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      grabCursor: true,
      watchOverflow: true,
      loop: true,
      a11y: { enabled: true },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: this.container.querySelector('.nad-handpicked-reviews__pagination') as HTMLElement,
        clickable: true,
      },
    });
  }

  public destroy(): void {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  static initializeAll(): void {
    document
      .querySelectorAll<HTMLElement>('.nad-handpicked-reviews')
      .forEach((el) => {
        if (!(el as any)._nadComponentInstance) {
          (el as any)._nadComponentInstance = new NADHandpickedReviews(el);
        }
      });
  }
}

// main-product can re-render on variant change (Section Rendering API),
// which replaces the block DOM. Re-initialize on those events.
document.addEventListener('product-info:loaded', () => {
  NADHandpickedReviews.initializeAll();
});
